"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogInitialState = void 0;
exports.catalogInitialState = {
    attributes: undefined,
    measures: undefined,
    dateDatasets: undefined,
    facts: undefined,
};
//# sourceMappingURL=catalogState.js.map